module.exports = __webpack_public_path__ + "static/media/special-offer-50-off.75aa70db.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/special-offer-50-off.png
// module id = 2162
// module chunks = 0